import api from '../api'

const state = {
  all: [],
  encodingProfile: null
}

const actions = {
  getEncodingProfiles: ({ state, commit }) => {
    return api.getAllEncodingProfiles().then(encodingProfiles => {
      return commit('setAllEncodingProfiles', encodingProfiles)
    })
  },
  assignEncodingProfile: ({ state, commit }, data) => {
    return api.assignEncodingProfile(data)
  },
  deleteEncodingProfile: ({ state, commit }, id) => {
    return api.deleteSingleEncodingProfile(id).then(() => {
      return commit('setSingleEncodingProfile', null)
    })
  },
  addEncodingProfile: ({ state, commit }, data) => {
    return api.addSingleEncodingProfile(data).then((response) => {
      return commit('setSingleEncodingProfile', response.data)
    })
  },
  updateEncodingProfile: ({ state, commit }, data) => {
    return api.updateSingleEncodingProfile(data).then((response) => {
      return commit('setSingleEncodingProfile', response.data)
    })
  },
  cloneEncodingProfile: ({ state, commit }, data) => {
    return api.cloneEncodingProfile(data).then(() => {
    })
  }
}

const mutations = {
  setAllEncodingProfiles (state, encodingProfiles) {
    state.all = encodingProfiles
  },
  setSingleEncodingProfile (state, encodingProfile) {
    state.encodingProfile = encodingProfile
  }
}

const getters = {
  all: state => {
    return state.all
  },
  encodingProfile: state => {
    return state.encodingProfile
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/encodingProfiles.js